import clientChooserView from './clientChooserView.html';
import './clientChooserStyles.css';
import _ from 'lodash';
import { spliceOutWhere } from 'components/sharpr/util/spliceOut.js';
import { ensure } from 'components/sharpr/ensure/ensure.js';

export function clientChooserComponent() {
	return {
		bindings: {
			onAfterChoose: '&?',
			reloadState: '<?',
			onNoHubs: '&?',
			allowHiding: '<',
		},
		controllerAs: 'vm',
		controller: clientChooserComponentCtrl,
		template: clientChooserView,
	};
}

class clientChooserComponentCtrl {
	constructor(Identity, Cfg, Theme, $state, PartnerLinks, ClientChooserWhitelist) {
		'ngInject';
		// save injections
		this.Identity = Identity;
		this.Cfg = Cfg;
		this.Theme = Theme;
		this.$state = $state;
		this.PartnerLinks = PartnerLinks;
		// self-bind some functions
		this.isHubAllowed = this.isHubAllowed.bind(this);
		// setup
		this.current = this.Identity.currentClient() || {};
		this.clients = this.Identity.allowedClients() || [];
		this.allowedIds = this.clients.map(client => client.id);
		this.clients.forEach(client => {
			client.search = `${client.name.toLocaleLowerCase()} - @${client.id}`;
		});

		this.clientSearchText = '';
		this.use = this.use.bind(this);
		if (this.clients.length > 200) {
			this.maxWhenEmpty = 100;
		} else {
			this.maxWhenEmpty = Infinity;
		}

		this.ClientChooserWhitelist = ClientChooserWhitelist;
		this.displayedClients = this.clients.filter(this.ClientChooserWhitelist.filter);
		if (!this.displayedClients.length && this.onNoHubs) {
			this.onNoHubs();
		}
		this.mustManuallyOpen = this.allowHiding && Cfg.read('Ui.hub_chooser_visibility') === 'manual';
		this.isVisible = !this.mustManuallyOpen || localStorage.getItem('hub_chooser_visibility') === '1';
		this.loadRecents();
	}

	toggleVisibility() {
		const newVisibility = this.isVisible ? '0' : '1';
		localStorage.setItem('hub_chooser_visibility', newVisibility);
		this.isVisible = !this.isVisible;
	}

	loadRecents() {
		try {
			this.recent = JSON.parse(localStorage.getItem('recentHubs') || '[]');
		} catch (e) {
			this.recent = [];
		}
		// remove duplicates (e.g. a hub you just visited)
		this.recent = _.uniq(this.recent, 'id');
		// run some filters
		this.recent = this.recent
			// ignore any bad data
			.filter(client => !!client.name)
			// ensure we don't show hubs we lost access to
			.filter(this.isHubAllowed)
			// reduce to whitelisted hubs
			.filter(this.ClientChooserWhitelist.filter);
	}

	isHubAllowed(hub) {
		return this.allowedIds.indexOf(hub.id) > -1;
	}

	async use(hub) {
		this.dropdownOpen = false;
		const clientRecord = {
			id: hub.id,
			name: hub.name || hub.$label,
			$label: hub.$label || hub.name,
			account_id: hub.account_id,
		};
		this.current = clientRecord;
		await this.Identity.useHub(hub.id);
		this.onAfterChoose && (await this.onAfterChoose({ $client: clientRecord }));
		this.addRecent(clientRecord);
		if (this.reloadState) {
			// check and act on the new hub's settings related to the home page
			/// the new settings are already in place -- it happens in `this.Identity.useHub`
			if (
				ensure.number(this.Cfg.read('Features.home_page_on_hub_switch')) &&
				ensure.string(this.Cfg.read('Features.home_page'))
			) {
				// go to the new hub's or the user's home page (user's setting has precedence)
				window.location.href = ensure.string(this.Cfg.read('Features.home_page'));
			} else {
				this.$state.go(this.$state.current, {}, { reload: true });
			}
		}
	}

	addRecent(client) {
		// if it was there, remove the client from the list of recent ones
		spliceOutWhere(this.recent, { id: client.id });
		// and add it as the first item
		this.recent.unshift(client);
		// max of 10 recent entries
		// In loadRecents() we filter by allowed hubs
		// In the html template, we'll limit to 5
		this.recent = this.recent.slice(0, 10);
		try {
			localStorage.setItem('recentHubs', JSON.stringify(this.recent));
		} catch (e) {}
	}
}
